// Used for local storage
export const APP_ID_KEY = 'NB_APP_ID';

// Used to force app reach /handover route on app init
export const DEFAULT_APP_ID = 'NOT_INITIALIZED';
